import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Grid, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Pagination } from '@components/common';
import PaymentsContext from '../paymentsContext';

const PaymentFooter = ({ onViewPaymentHistory }) => {
	const {
		officerOrAgency,
		totalCount,
		activePage,
		applyFilter,
		loading,
		filters: {
			displayCount,
			pageNumber,
		},
	} = useContext(PaymentsContext);

	useEffect(() => {
		applyFilter('pageNumber')(1);
		applyFilter('displayCount')(25);
	}, [officerOrAgency]);

	return (
		<Grid>
			<Choose>
				<When condition={activePage === 'paid'}>
					<div className="row reports-link">
						<div className="col-sm-12 text-center">
							<Link to="/reports" onClick={onViewPaymentHistory}>
								See older paid invoices in reports
							</Link>
						</div>
					</div>
				</When>
				<Otherwise>
					<Row>
						<Col md={12} sm={12}>
							<Pagination
								disabled={loading}
								totalCount={totalCount || 0}
								displayCount={displayCount}
								pageNumber={pageNumber}
								onPaginate={applyFilter('pageNumber')}
								onDisplayCountChange={applyFilter('displayCount')}
							/>
						</Col>
					</Row>
				</Otherwise>
			</Choose>
		</Grid>
	);
};

PaymentFooter.propTypes = {
	onViewPaymentHistory : PropTypes.func.isRequired,
};

export default PaymentFooter;
